import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetAuthFormEmail } from './auth-form.actions';
import { AuthFormStateModel } from './model/auth-form-state-model';

@State<AuthFormStateModel>({
  name: 'authForm',
  defaults: {
    email: ''
  }
})
@Injectable()
export class AuthFormState {
  @Selector()
  static email(state: AuthFormStateModel): string {
    return state.email;
  }

  @Action(SetAuthFormEmail)
  setAuthFormEmail(ctx: StateContext<AuthFormStateModel>, { email }: SetAuthFormEmail): void {
    ctx.patchState({
      email: email ?? ''
    });
  }
}
